export const SRQ_PLACEHOLDER_EVENT_TYPE = 'srq_placeholder'

type CalendarEventLike = {
  type?: string | null
  srq_quizzes_due_today?: number | null
}

export const isSrqPlaceholderEvent = (
  event?: CalendarEventLike | null
): boolean => event?.type === SRQ_PLACEHOLDER_EVENT_TYPE

/** Calendar events shown in the day list (excludes SRQ metadata placeholders). */
export const getCalendarEventsForDisplay = <T extends CalendarEventLike>(
  events?: T[] | null
): T[] => {
  if (!Array.isArray(events) || events.length === 0) {
    return []
  }

  return events.filter(event => !isSrqPlaceholderEvent(event))
}

/** Reads srq_quizzes_due_today from calendar event objects for a day. */
export const getSrqQuizzesDueTodayFromEvents = (
  events?: Array<{ srq_quizzes_due_today?: number | null }> | null
): number => {
  if (!Array.isArray(events) || events.length === 0) {
    return 0
  }

  let maxCount = 0

  events.forEach(event => {
    const count = Number(event?.srq_quizzes_due_today)
    if (Number.isFinite(count) && count > maxCount) {
      maxCount = count
    }
  })

  return maxCount
}

/** Formats badge count: 5, 22, 557, 1,017 */
export const formatSrqQuizzesDueTodayCount = (count: number): string =>
  Math.max(0, Math.floor(count)).toLocaleString('en-US')
